module.exports = __webpack_public_path__ + "img/home-img-3.06dafe82.webp";